<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1 class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between" *ngIf="!isMordal">
    <span class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        入金通知報告画面
    </span>
    <mat-icon style="opacity: 0.5;">info_outline</mat-icon>
</h1>
<h2 class="tw-flex tw-flex-row tw-flex-wrap tw-justify-between" *ngIf="isMordal">
    <span class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        入金通知報告画面
    </span>
    <mat-icon [ngStyle]="{ 'opacity': isEdit ? '' : '0.5' }" (click)=" isEdit && onClickIcon()">info_outline</mat-icon>
</h2>
<form [formGroup]="regInfRequestForm" #formDirective="ngForm" (ngSubmit)="regist(formDirective)">
    <app-sgke110d-info *ngIf="newInitialhyojiInfo || correctionInitialhyojiInfo"
        [newInitialhyojiInfo]="newInitialhyojiInfo" [correctionInitialhyojiInfo]="correctionInitialhyojiInfo"
        [gamenHyojiInfo]="gamenHyojiInfo" [isMordal]="isMordal" [isEdit]="isEdit" (cancelButtonClickEmitter)="cancel()"
        (removeButtonClickEmitter)="remove()">
    </app-sgke110d-info>
</form>